import type { FaireProductEntity } from "../../entity_types/product";

export const p_enc9u3r4un: FaireProductEntity = {
  token: "p_enc9u3r4un",
  type: "product",
  name: "Thank You Stickers & Cards Set",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/e9d150343a70b65c447ab5f8d6e8fb1cb64d0474a3d4e23ebb4345e6e6d96099.jpeg",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
